// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 MindTenet LLC
// This file is part of Undef Engine.

/**
 * SpectatorCard - Individual spectator display
 *
 * Shows spectator name, avatar, join time, and guest status.
 */

import type { SpectatorInfo } from '../../types/game';

interface SpectatorCardProps {
  spectator: SpectatorInfo;
}

export function SpectatorCard({ spectator }: SpectatorCardProps) {
  const joinedAt = new Date(spectator.joined_at).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <div
      className="flex items-center gap-3 bg-white/5 rounded-lg p-3"
      data-testid={`spectator-card-${spectator.player_id}`}
    >
      {/* Avatar */}
      <div className="h-8 w-8 rounded-full bg-gray-500 flex items-center justify-center text-sm font-bold text-white">
        👁️
      </div>

      {/* Info */}
      <div className="flex-1">
        <p className="font-medium text-sm" data-testid="spectator-name">
          {spectator.display_name}
          {spectator.is_guest && (
            <span className="ml-2 text-xs text-gray-400" title="Guest">
              (Guest)
            </span>
          )}
        </p>
        <p className="text-xs text-gray-400" data-testid="spectator-join-time">
          Joined at {joinedAt}
        </p>
      </div>
    </div>
  );
}
